"use client";

import { useState } from "react";
import StockShareHoldingTabClient from "./StockShareHoldingTab";
import {
  IFIIHoldingQuarterly,
  IInstitutionHoldingQuarterly,
  IPromoterHoldingQuarterly,
  IStockShareHolding,
} from "../../interfaces/StockShareholding.interface";
import { IShareholdingContent } from "../../interfaces/StockShareHoldingPattern.interface";
import dynamic from "next/dynamic";
import BFLSkeleton from "@repo/shared-ui/BFLSkeleton";
import BFLLazyLoad from "@repo/shared-ui/BFLLazyLoad";
import ShareholdingSummaryTable from "./ShareholdingSummaryTable";

import ShareholdingSummaryTab from "./ShareholdingSummaryTab";

const StockShareHoldingGraph: any = dynamic(
  () => import("./StockShareHoldingGraph.tsx") as any,
  {
    ssr: false,
    loading: () => <BFLSkeleton count={1} height={200} />,
  },
);
interface IGraphData {
  qly: (
    | IPromoterHoldingQuarterly
    | IInstitutionHoldingQuarterly
    | IFIIHoldingQuarterly
  )[];
}
const StockShareHoldingClientWrapper = ({
  stockShareHolding,
  content,
}: {
  stockShareHolding: IStockShareHolding;
  content: IShareholdingContent;
}) => {
  const SHARE_HOLDING_TAB: Record<"shs" | "hph" | "hmfh" | "hFiih", string> = {
    shs: content?.tabTitleText || "Shareholding Summary",
    hph: content?.tabTitleTextPromo || "Historical Promoter Holding",
    hmfh: content?.tabTitleTextMf || "Historical MF Holding",
    hFiih: content?.tabTitleTextFii || "Historical FII Holding",
  };
  const [selectedTab, setSelectedTab] = useState<string>(
    SHARE_HOLDING_TAB["shs"] || "Shareholding Summary",
  );

  const tabKey =
    (Object.keys(SHARE_HOLDING_TAB).find(
      (k) =>
        SHARE_HOLDING_TAB[k as keyof typeof SHARE_HOLDING_TAB] === selectedTab,
    ) as keyof IStockShareHolding) || "shs";

  return (
    <>
      <StockShareHoldingTabClient
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        SHARE_HOLDING_TAB={SHARE_HOLDING_TAB}
      />
      <br />

      {selectedTab !== SHARE_HOLDING_TAB["shs"] ? (
        stockShareHolding?.[tabKey] && (
          <BFLLazyLoad threshold={0.4}>
            <StockShareHoldingGraph
              graphData={stockShareHolding[tabKey] as IGraphData}
            />
          </BFLLazyLoad>
        )
      ) : (
        <div className="mb-6 gap-10 lg:flex">
          <ShareholdingSummaryTab
            data={stockShareHolding?.["pieChart"] || {}}
            graphLabel={[
              content?.others,
              content?.promHolding,
              content?.fii,
              content?.dii,
              content?.promShares,
            ]}
          />
          <ShareholdingSummaryTable
            data={stockShareHolding?.["shs"] || []}
            tableHeader={content?.tableColumnDetails?.[0] || {}}
            modalContent={{
              buttonText: content?.popUpCtaText,
              title: content?.popUpTitleText,
            }}
          />
        </div>
      )}
    </>
  );
};

export default StockShareHoldingClientWrapper;
